import { GetActionsSummaryResponseDTO } from '@src/services/tools/modules/v1/scripts/dto/tools-requests.dto';
import { colors } from '@src/styles';

const getPercent = (value: number, total: number) => {
  if (total === 0) return 0;
  return (value / total) * 100;
};

export const getProgressItems = (summary: GetActionsSummaryResponseDTO) => [
  {
    label: `Pendente (${getPercent(summary.pending, summary.total).toFixed(2) || 0}%)`,
    color: '#6B7280',
    percent: getPercent(summary.pending, summary.total) || 0,
  },
  {
    label: `Aguardando (${getPercent(summary.waiting, summary.total).toFixed(2) || 0}%)`,
    color: '#fffb02ff',
    percent: getPercent(summary.waiting, summary.total) || 0,
  },
  {
    label: `Processando (${getPercent(summary.running, summary.total).toFixed(2) || 0}%)`,
    color: '#60A5FA',
    percent: getPercent(summary.running, summary.total) || 0,
  },
  {
    label: `Concluído (${getPercent(summary.concluded, summary.total).toFixed(2) || 0}%)`,
    color: colors.primary.green,
    percent: getPercent(summary.concluded, summary.total) || 0,
  },
  {
    label: `Falho (${getPercent(summary.failed, summary.total).toFixed(2) || 0}%)`,
    color: colors.primary.warning,
    percent: getPercent(summary.failed, summary.total) || 0,
  },
  {
    label: `Ignorado (${getPercent(summary.skipped, summary.total).toFixed(2) || 0}%)`,
    color: '#f58230ff',
    percent: getPercent(summary.skipped, summary.total) || 0,
  },
];
